import { render, staticRenderFns } from "./Mattress.vue?vue&type=template&id=5e9462be"
import script from "./Mattress.vue?vue&type=script&lang=js"
export * from "./Mattress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports